export const LOAD_PHOTO_GALLERIES = "PHOTO_GALLERY_LOAD_PHOTO_GALLERIES";
export const RESET_PHOTO_GALLERIES = "PHOTO_GALLERY_RESET_PHOTO_GALLERIES";
export const LOAD_PHOTO_GALLERY = "PHOTO_GALLERY_LOAD_PHOTO_GALLERY";
export const RESET_PHOTO_GALLERY = "PHOTO_GALLERY_RESET_PHOTO_GALLERY";
export const RESET_PHOTO_GALLERY_STATE = "RESET_PHOTO_GALLERY_STATE";
